import {
  CountdownWidget,
  HonourRollWidget,
  ImageWidget,
  ImageWidgetSourceEnum,
  ItemTableCardType,
  ItemTableWidget,
  ThermometerWidget,
  TextWidget,
  TotalRaisedWidget,
  RaffleDrawWidget,
  RaffleWinnersWidget,
  NotificationWidget,
  NotifTypeEnum,
  SmartTextWidget,
  QrCodeWidget,
  TeamScoringWidget,
  VideoWidget,
  HonorRollLayoutDirectionEnum,
} from 'libs/gb-dashboard/presenter/data-access-presenter-widgets/src/lib/+state/presenter-widgets.models'

export const defaultText: Partial<TextWidget> = {
  text: 'This is a default text block.',
  font_family: '',
  font_size: 16,
  font_weight: 'normal',
  font_style: 'normal',
  text_align: 'left',
  text_decoration: 'none',
  line_height: 1.5,
  letter_spacing: 0,
  color: '#000',
  x: 50,
  x_unit: '%',
  y: 50,
  y_unit: '%',
}

export const defaultSmartText: Partial<SmartTextWidget> = {
  text: 'galabid.com/',
  font_family: '',
  font_size: 16,
  font_weight: 'normal',
  text_align: 'left',
  color: '',
  x: 50,
  x_unit: '%',
  y: 50,
  y_unit: '%',
}

export const getDefaultItemTableWidget = (): Partial<ItemTableWidget> => ({
  x: 0.5,
  x_unit: '%',
  y: 0.5,
  y_unit: '%',
  width_unit: '%',
  height_unit: '%',
  rotate_z: 0,
  rotate_z_unit: 'deg',
  columns: 5,
  rows: 1,
  slide_interval: 10,
  font_size: 12,
  card_type: ItemTableCardType.COMPACT_TABLE,
  transition: 'fade-in',
  image_contained: false,
  show_item_type: true,
  item_name_max_lines: 3,
  table_primary_color: 'accent_color',
  table_accent_color: 'background_color',
  table_background_color: 'primary_color',
  hidden_items: [],
  width: 99,
  height: 50,
})

export const getDefaultTotalRaisedWidget = (textColor = '#000000'): Partial<TotalRaisedWidget> => ({
  label: 'Total raised',
  total_raised: '0.00',
  track_bids: true,
  track_donations: true,
  track_purchases: true,
  track_raffles: true,
  track_ticket_sales: true,
  track_paddle_raise_pledges: true,
  base_total_raised_enabled: false,
  font_family: '',
  font_size: 30,
  font_weight: 'normal',
  text_align: 'left',
  color: textColor,
  height: null,
  height_unit: '%',
  opacity: 1,
  rotate_z: 0,
  rotate_z_unit: 'deg',
  width: null,
  width_unit: '%',
  x: 50,
  x_unit: '%',
  y: 50,
  y_unit: '%',
  z: 10,
})

export const getDefaultCountdownWidget = (): Partial<CountdownWidget> => ({
  font_family: '',
  font_weight: 'bold',
  font_size: 48,
  text_align: 'center',
  timer_type: '',
  letter_spacing: 1,
  timeout_text: 'Countdown finished',
  plus_overtime_label: true,
  end_on_auction_schedule_close: false,
  end: '',
  height: null,
  height_unit: '%',
  opacity: 1,
  rotate_z: 0,
  rotate_z_unit: 'deg',
  width: null,
  width_unit: '%',
  x: 50,
  x_unit: '%',
  y: 50,
  y_unit: '%',
  z: 10,
})

const defaultHonourRollWidget = {
  slide_interval: 26,
  show_item_name: true,
  show_item_alias: true,
  font_size: 12,
  latest_activities: 10,
  hidden_items: [],
  height_unit: '%',
  opacity: 1.0,
  rotate_z: 0,
  rotate_z_unit: 'deg',
  width_unit: '%',
  text_align: 'left',
  font_weight: 'normal',
  x_unit: '%',
  y: 65,
  y_unit: '%',
}

export const defaultHonourRollWidgetVertical = {
  ...defaultHonourRollWidget,
  columns: 5,
  rows: 1,
  layout_direction: HonorRollLayoutDirectionEnum.VERTICAL,
  transition: 'scroll-right',
  height: 34,
  width: 100.0,
  x: 0,
  y: 65,
}

export const defaultHonourRollWidgetHorizontal = {
  ...defaultHonourRollWidget,
  columns: 1,
  rows: 5,
  layout_direction: HonorRollLayoutDirectionEnum.HORIZONTAL,
  transition: 'scroll-top',
  height: 100,
  width: 30,
  x: 10,
  y: 0,
}

export const getDefaultHonourRollWidget = (): Partial<HonourRollWidget> => ({
  ...defaultHonourRollWidgetHorizontal,
  table_primary_color: 'accent_color',
  table_accent_color: 'primary_color',
})

export const defaultRaffleDrawWidget: Partial<RaffleDrawWidget> = {
  width: 50,
  height: 15,
  height_unit: '%',
  width_unit: '%',
  font_size: 70,
  x: 25,
  y: 11,
  x_unit: '%',
  y_unit: '%',
  primary_color: 'background_color',
  primary_text_color: '#000000',
}

export const getDefaultRaffleWinnersWidget = (textColor = '#000000'): Partial<RaffleWinnersWidget> => ({
  width: 90,
  height: 60,
  height_unit: '%',
  width_unit: '%',
  font_size: 15,
  primary_color: 'primary_color',
  primary_text_color: textColor,
  accent_color: 'accent_color',
  x: 5,
  y: 32,
  x_unit: '%',
  y_unit: '%',
  text_align: 'left',
  font_weight: 'normal',
})

export const getDefaultThermometerWidget = (): Partial<ThermometerWidget> => ({
  amount_raised: 0,
  fundraising_progress: 0,
  fundraising_target: 1000,
  track_pledges_only: false,
  base_total_raised_enabled: false,

  thermometer_background_color: 'background_color',
  thermometer_border_color: 'primary_color',
  thermometer_color: 'warning_color',

  custom_image: null,

  border_color: 'primary_color',
  border_style: '',
  border_width: 8,
  border_width_unit: 'px',
  border_radius: null,
  border_radius_unit: 'px',
  padding: null,
  padding_unit: 'px',
  box_shadow: '',

  height: 70,
  height_unit: '%',
  opacity: 1,
  rotate_z: 0,
  rotate_z_unit: 'deg',
  width: 13,
  width_unit: '%',
  x: 55.948,
  x_unit: '%',
  y: 12.249,
  y_unit: '%',
  z: 1,
})

export const getDefaultNotificationWidget = (): Partial<NotificationWidget> => ({
  width: 50,
  height: 50,
  height_unit: '%',
  width_unit: '%',
  font_size: 17,
  font_weight: 'normal',
  background_color: 'primary_color',
  primary_text_color: '#ffffff',
  notif_secondary_background_color: 'accent_color',
  notif_secondary_color: '#ffffff',
  x: 25,
  x_unit: '%',
  y: 25,
  y_unit: '%',
  z: 10,
  notif_type: NotifTypeEnum.POPOUT_A,
  image_contained: false,
  show_bid_notifications: true,
  show_purchase_notifications: true,
  show_donation_notifications: true,
  show_custom_notifications: true,
})

export const getDefaultQrCodeWidget = (): Partial<QrCodeWidget> => ({
  x: 25,
  x_unit: '%',
  y: 25,
  y_unit: '%',
  width: 35,
  width_unit: '%',
  height: 60,
  height_unit: '%',
  z: 10,
  font_size: 16,
  color: '#000',
})

export const getDefaultTeamScoringWidget = (): Partial<TeamScoringWidget> => ({
  x: 1.5,
  x_unit: '%',
  y: 47,
  y_unit: '%',
  width_unit: '%',
  height_unit: '%',
  rotate_z: 0,
  rotate_z_unit: 'deg',
  columns: 1,
  rows: 5,
  slide_interval: 10,
  font_size: 12,
  card_type: 'standard_table',
  transition: 'fade-in',
  table_primary_color: 'accent_color',
  table_accent_color: 'background_color',
  table_background_color: 'primary_color',
  text_align: 'center',
  hidden_teams: [],
  width: 97,
  height: 50,
})

export const getDefaultVideoWidget = (): Partial<VideoWidget> => ({
  x: 10,
  x_unit: '%',
  y: 10,
  y_unit: '%',
  width: 80,
  width_unit: '%',
  height: 60,
  height_unit: '%',
  z: 10,
  video_url: '',
})

export const getDefaultImageWidget = (): Partial<ImageWidget> => ({
  x: 75,
  x_unit: '%',
  y: 25,
  y_unit: '%',
  width: 20,
  width_unit: '%',
  height: null,
  height_unit: '%',
  image_source: ImageWidgetSourceEnum.Custom,
})
